import saveAs from 'save-as';
import ApexCharts from 'apexcharts';

export function download(filename, filetype, data) {
    let blob = new Blob([data], { type: filetype });
    saveAs(blob, filename);
}

// for generated PDF in Analytics Graph
export const getPNGDataURI = async (id) => {
    // Wait up to ~2s for the chart to exist
    for (let i = 0; i < 20; i++) {
        const chart = ApexCharts.getChartByID(id);
        if (chart) return ApexCharts.exec(id, 'dataURI');
        await new Promise((r) => setTimeout(r, 100));
    }
    throw new Error(`Chart ${id} not found (not mounted yet)`);
};
export function parseQuestionId(questionId) {
    const result = /^((?:learning)|(?:reading)|(?:writing)|(?:oralcommunication)|(?:numeracy))-l(\d*)q(\d*)(a|b|c|d|e)$/.exec(questionId);
    if (!result) {
        throw new Error(`Error while attempting to parse QuestionId '${questionId}'`);
    }
    const [id, skill, level, number, variant] = result;
    return {
        id,
        skill,
        // $FlowFixMe:  Number enums don't support parseInt.
        level: parseInt(level, 10),
        // $FlowFixMe:  Number enums don't support parseInt.
        number: parseInt(number, 10),
        variant
    };
}

export const generateMongoLikeId = () => {
    const timestamp = Math.floor(new Date().getTime() / 1000).toString(16); // 4 bytes for timestamp
    const randomHex = 'xxxxxxxxxxxxxxxx'
        .replace(/[x]/g, () => {
            // 8 bytes for random data
            return Math.floor(Math.random() * 16).toString(16);
        })
        .toLowerCase();

    // Combine timestamp and random hex to create a 24-character hex string
    return timestamp + randomHex;
};

export const getCurrentWeekDateRange = () => {
    const today = new Date();
    const dayOfWeek = today.getDay(); // Sunday is 0, Monday is 1, ..., Saturday is 6

    // Calculate the difference to get to Monday
    // If today is Sunday (0), subtract 6 days to get to the previous Monday.
    // Otherwise, subtract (dayOfWeek - 1) days to get to the current week's Monday.
    const diffToMonday = dayOfWeek === 0 ? -6 : -(dayOfWeek - 1);

    const monday = new Date(today);
    monday.setDate(today.getDate() + diffToMonday);
    monday.setHours(0, 0, 0, 0); // Set to the very beginning of Monday

    const sunday = new Date(monday);
    sunday.setDate(monday.getDate() + 6);
    sunday.setHours(23, 59, 59, 999); // Set to the very end of Sunday

    return {
        start: monday,
        end: sunday
    };
};

export function validatePasswordChars(str) {
    const result = {
        status: true,
        uppercase: false,
        lowercase: false,
        special: false,
        number: false
    };

    // Check for lowercase letters
    if (/[a-z]/.test(str)) result.lowercase = true;

    // Check for uppercase letters
    if (/[A-Z]/.test(str)) result.uppercase = true;

    // Check for digits
    if (/\d/.test(str)) result.number = true;

    // Check for special characters
    if (/[!@#$%^&*()_+\-=[\]{};:'",.<>/?\\|`~]/.test(str)) result.special = true;

    // Determine if all conditions are met
    result.status = result.uppercase && result.lowercase && result.special && result.number;

    return result;
}
